import React from 'react';

const RichTextRenderer = ({ content, className = '' }) => {
    if (!content) return null;

    const renderContent = (text) => {
        if (!text) return '';
        
        // Convert markdown-like formatting to HTML
        let html = text
            // Bold
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            // Italic
            .replace(/\*(.*?)\*/g, '<em>$1</em>')
            // Underline
            .replace(/<u>(.*?)<\/u>/g, '<u>$1</u>')
            // Links
            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">$1</a>')
            // Line breaks
            .replace(/\n/g, '<br>')
            // Bullet points
            .replace(/^• (.*$)/gm, '<li class="ml-4">$1</li>')
            // Numbered lists
            .replace(/^\d+\. (.*$)/gm, '<li class="ml-4">$1</li>');
        
        // Wrap consecutive <li> elements in <ul>
        html = html.replace(/(<li[^>]*>.*<\/li>)/gs, '<ul class="list-disc list-inside space-y-1">$1</ul>');
        
        return html;
    };

    return (
        <div 
            className={`rich-text-content prose prose-sm max-w-none ${className}`}
            dangerouslySetInnerHTML={{ __html: renderContent(content) }}
        />
    );
};

export default RichTextRenderer;
